import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getEventTypes,
  createEventType,
  updateEventType,
  deleteEventType,
} from '../services/api/teamEvents';

export function useEventTypes() {
  return useQuery({
    queryKey: ['eventTypes'],
    queryFn: getEventTypes,
  });
}

export function useCreateEventType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ name, maxParticipants, rsvpDeadlineDays }: { name: string; maxParticipants?: number | null; rsvpDeadlineDays?: number | null }) =>
      createEventType(name, maxParticipants, rsvpDeadlineDays),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['eventTypes'] });
    },
  });
}

export function useUpdateEventType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, name, maxParticipants, rsvpDeadlineDays }: { id: number; name: string; maxParticipants?: number | null; rsvpDeadlineDays?: number | null }) =>
      updateEventType(id, name, maxParticipants, rsvpDeadlineDays),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['eventTypes'] });
    },
  });
}

export function useDeleteEventType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteEventType(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['eventTypes'] });
    },
  });
}
